import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanLoad } from '@angular/router';
import { AuthNGuardService } from '../services/authn-guard.service';

@Injectable()
export class CanLoadGuard implements CanLoad {

    constructor(private _authService: AuthNGuardService, private activatedRoute: ActivatedRoute) {}

    async canLoad(route: ActivatedRouteSnapshot): Promise<boolean> {
        return await this._authService.canActivate(route);
    }
}
